import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import BrandStatement from "./components/BrandStatement";
import SignatureExperiences from "./components/SignatureExperiences";
import WhySection from "./components/WhySection";
import EditorialSection from "./components/EditorialSection";
import TestimonialsSection from "./components/TestimonialsSection";
import InquiryCtaSection from "./components/InquiryCtaSection";

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <BrandStatement />
      <SignatureExperiences />
      <WhySection />
      <EditorialSection />
      <TestimonialsSection />
      <InquiryCtaSection />
      <Footer />
    </main>
  );
}
